import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/enums';

/**
 * Guarda de Activación de Negocio.
 * Asegura que los Dueños completen su registro de empresa y esperen activación.
 * Sincronizada para evitar bloqueos asíncronos en Zoneless.
 */
export const activationGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // 1. Verificar si hay un perfil cargado, si no, intentamos cargarlo
    const userProfile = authService.userProfile();
    if (!userProfile) {
        // Si no hay perfil, de momento no bloqueamos aquí (se encarga el authGuard de inicializar)
        return true;
    }

    const role = userProfile.role;
    const businessId = userProfile.business_id;

    // 2. Si no es dueño o es Superadmin, saltamos esta guarda
    if (role === UserRole.SUPERADMIN) return true;
    if (role !== UserRole.OWNER) return true;

    const url = state.url;

    // 3. Dueño sin empresa creada: Mandar a 'Mi Organización'
    if (!businessId) {
        if (url.includes('admin/my-organization')) return true;
        return router.createUrlTree(['/admin/my-organization']);
    }

    // 4. Con empresa: Verificamos el estado reactivo del negocio
    const isEnabled = authService.businessEnabled();

    if (!isEnabled) {
        // Permitimos estar en 'admin/my-organization' para ver el banner
        if (url.includes('admin/my-organization') || url.includes('activation-pending')) {
            return true;
        }
        // Bloqueo total del resto de rutas operativas
        return router.createUrlTree(['/admin/my-organization']);
    }

    // 5. Empresa habilitada: No permitir volver a 'pending'
    if (url.includes('activation-pending')) {
        return router.createUrlTree(['/admin/dashboard']);
    }

    return true;
};
